<!--  -->
<template>
  <div class="app-container">
    <div class="select_box">
      <div>
        <el-input v-model="query.account_id" class="select_input" placeholder="请输入推广账户id" />
        <el-input v-model="query.audience_id" class="select_input" placeholder="请输入人群包id" />
        <el-input v-model="query.audience_name" class="select_input" placeholder="请输入人群包名称" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addpeople">新增人群包</el-button>
      </div>

    </div>
    <el-table
      v-loading="loadingtable"
      :data="tableData"
      border
      max-height="700"
    >
      <el-table-column
        prop="account_id"
        label="推广账户id"
        width="100"
        align="center"
      />
      <el-table-column
        prop="audience_id"
        label="人群包ID"
        width="150"
        align="center"
      />
      <el-table-column
        prop="audience_name"
        label="人群名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="description"
        label="人群描述"
        width="150"
        align="center"
      />
      <el-table-column
        prop="type"
        label="人群类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="source"
        label="人群来源"
        width="150"
        align="center"
      />
      <!-- <el-table-column
        prop="external_audience_id"
        label="广告主对人群在自己系统里的编码"
        width="170"
        align="center"
      /> -->
      <el-table-column
        prop="status"
        label="处理状态"
        width="150"
        align="center"
      />
      <!-- <el-table-column
        prop="user_id_type"
        label="号码包用户 id 类型"
        width="150"
        align="center"
      /> -->
      <el-table-column
        prop="file_name"
        label="文件名称"
        width="280"
        align="center"
      />
      <!-- <el-table-column
        prop="operation_type"
        label="文件操作类型"
        width="100"
        align="center"
      /> -->
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        width="150"
      />
      <el-table-column
        prop="open_app_id"
        label="open_app_id"
        align="center"
      />
      <!-- <el-table-column
        prop="custom_audience_file_id"
        label="数据文件id"
        width="100"
        align="center"
      />
      <el-table-column
        prop="cooperated"
        label="cooperated"
        width="100"
        align="center"
      />
      <el-table-column
        prop="error_code"
        label="error_code"
        width="100"
        align="center"
      /> -->
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="(command)=>handleCommand(command,scope.row)"
          >
            <span
              class="el-dropdown-link"
              style="cursor: pointer;"
            >
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="dataReport">
                数据报告
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增人群包"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="30%"
    >
      <addpersonnel ref="addpersonnelview" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import addpersonnel from './components/addpersonnel.vue'
import { customAudiencesList } from '@/api/ad.js'
export default {
  components: { PaginationRight, addpersonnel },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        account_id: '',
        audience_id: null, // 人群包id
        audience_name: null// 人群包名称
      },
      total: null,
      moneyLoading: false,
      dialogVisible: false,
      options: [
        {
          label: '微信公众号',
          value: 1
        },
        {
          label: '腾讯广告(adq)',
          value: 2
        }
      ],
      tableData: [],
      arr: [15545, 55455, 56.6556, 455425.2],
      title: '',
      loadingtable: false
    }
  },
  created() {
    // this.list()
  },
  mounted() {

  },
  methods: {
    search() {
      this.query.page = 1
      this.list()
    },
    async list() {
      try {
        this.loadingtable = true
        const data = await customAudiencesList(this.query)
        this.tableData = data.data.list
        this.total = data.data.total
        this.loadingtable = false
        console.log('列表', data.data)
      } catch {
        this.loadingtable = false
        this.tableData = []
      }
    },
    reast() {
      this.query.page = 1
      this.query.account_id = null
      this.query.audience_id = null
      this.query.audience_name = null
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    getURLData() {

    },
    addpeople() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addpersonnelview.send(1)
      })
    },
    updata() {
      this.dialogVisible = false
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
}
.select_input{
  width: 200px;
  margin-right: 20px;
}
</style>
